import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    joinParts,
} from "components/detail";

export const PtDateShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    설명회 날짜 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    설명회 날짜를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem
                            label="설명회 날짜 시간"
                            value={joinParts([record?.date, record?.time], "  ")}
                        />
                        <FieldItem label="허용인원" value={record?.ablePersonNum} />
                        <FieldItem label="신청인원" value={record?.participantCnt} />
                        <FieldItem label="대기인원" value={record?.waitingCnt} />
                        <FieldItem label="버전" value={record?.version} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="메타 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
